import { render } from "./SystemDashboard.vue?vue&type=template&id=672b1d29&scoped=true"
import script from "@/assets/Js/systemset/systemdashboard.js?vue&type=script&lang=js&external"
export * from "@/assets/Js/systemset/systemdashboard.js?vue&type=script&lang=js&external"

import "@/assets/Css/systemset/systemdashboard.css?vue&type=style&index=0&id=672b1d29&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672b1d29"]])

export default __exports__